import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "mt-2 w-full bg-transparent border-b border-white/20 py-3 text-[#FDFBF7] placeholder-[#5c5850] focus:outline-none focus:border-[#D4AF37] transition-colors duration-300";

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6" data-testid="admin-login-page">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center mb-10">
          <img src="/logo-jayatk.png" alt="Jay Atk" className="h-10 w-auto" />
        </Link>

        <div className="border border-white/10 bg-black/40 backdrop-blur-xl p-10 gold-glow">
          <div className="flex items-center gap-2 mb-8">
            <Lock className="w-4 h-4 text-[#D4AF37]" />
            <span className="text-xs uppercase tracking-[0.25em] text-[#D4AF37]">Admin Access</span>
          </div>
          <form onSubmit={submit} className="space-y-8">
            <label className="block">
              <span className="text-[11px] uppercase tracking-[0.2em] text-[#A19D94]">Email</span>
              <input data-testid="login-email" type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" />
            </label>
            <label className="block">
              <span className="text-[11px] uppercase tracking-[0.2em] text-[#A19D94]">Password</span>
              <input data-testid="login-password" type="password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </label>
            {error && <p className="text-sm text-red-400" data-testid="login-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="login-submit"
              className="w-full text-xs uppercase tracking-[0.25em] border border-[#D4AF37] text-[#D4AF37] px-8 py-4 hover:bg-[#D4AF37] hover:text-black transition-colors duration-300 disabled:opacity-50">
              {loading ? "Signing in…" : "Enter Dashboard"}
            </button>
          </form>
        </div>
        <Link to="/" className="block text-center mt-6 text-xs uppercase tracking-[0.2em] text-[#5c5850] hover:text-[#D4AF37] transition-colors">← Back to site</Link>
      </motion.div>
    </div>
  );
}
